import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_ksubzp8puu: FaireCollectionEntity = {
  token: "pbc_ksubzp8puu",
  type: "collection",
  name: "Organic Cotton Knitted Baby Blankets & Gift Sets",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4cce412872934d826205d1bb50ccb443d0e5bc7349588164f06b810521e1f73c.jpeg",
  itemCount: 50,
  description:
    "Luxurious 100% organic cotton sweater knit & jacquard baby blankets & Gift Sets. \nUltra-Soft, lightweight, all-season, breathable, cozy and comfy. \nNon-toxic & natural fabrication for sensitive skin, eco-friendly & sustainable materials. \nEthically made by artisans in India.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:18.984Z",
    importedBy: "entity-db-import-collections",
  },
};
